import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=60e2e38c&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2e38c",
  null
  
)

export default component.exports